module.exports = __webpack_public_path__ + "static/media/insights-banner-desktop.308165aa.svg";